import Login from "../pages/Login";
import CambiarPassword from "../pages/CambiarPassword";
import RecuperarPassword from "../pages/RecuperarPassword";
import MentorDashboard from "../pages/MentorDashboard";
import PerfilUsuario from "../pages/PerfilUsuario";
import UsuarioDashboard from "../pages/UsuarioDashboard";
import Modulo1Diferencial from "../pages/Modulo1Diferencial";
import Modulo2Episodios from "../pages/Modulo2Episodios";
import Modulo3Semaforo from "../pages/Modulo3Semaforo";
import Modulo4DobleCapa from "../pages/Modulo4DobleCapa";
import Modulo5LineaBase from "../pages/Modulo5LineaBase";
import ResumenCapitulo1 from "../pages/ResumenCapitulo1";
import Modulo21MapaAmenaza from "../pages/Modulo21MapaAmenaza";
import Modulo22RadarExigencia from "../pages/Modulo22RadarExigencia";
import Modulo23ContratoOculto from "../pages/Modulo23ContratoOculto";
import Modulo24ArbolTemor from "../pages/Modulo24ArbolTemor";
import Modulo25Radiografia from "../pages/Modulo25Radiografia";
import ResumenCapitulo2 from "../pages/ResumenCapitulo2";
import Modulo31InventarioFrentes from "../pages/Modulo31InventarioFrentes";
import Modulo32DeberPrestado from "../pages/Modulo32DeberPrestado";
import Modulo33FiltroImpacto from "../pages/Modulo33FiltroImpacto";
import Modulo34TareaFaro from "../pages/Modulo34TareaFaro";
import Modulo35DAI from "../pages/Modulo35DAI";
import ResumenCapitulo3 from "../pages/ResumenCapitulo3";
import Modulo41Descomposicion from "../pages/Modulo41Descomposicion";
import Modulo42Microsenales from "../pages/Modulo42Microsenales";
import Modulo43Reescritura from "../pages/Modulo43Reescritura";
import Modulo44IntervencionVivo from "../pages/Modulo44IntervencionVivo";
import Modulo45Automatizacion from "../pages/Modulo45Automatizacion";
import ResumenCapitulo4 from "../pages/ResumenCapitulo4";
import Modulo51DetectorFriccion from "../pages/Modulo51DetectorFriccion";
import Modulo52VMV from "../pages/Modulo52VMV";
import Modulo53DisenoEntorno from "../pages/Modulo53DisenoEntorno";
import Modulo54ArranqueObligatorio from "../pages/Modulo54ArranqueObligatorio";
import Modulo55SistemaEjecucion from "../pages/Modulo55SistemaEjecucion";
import ResumenCapitulo5 from "../pages/ResumenCapitulo5";
import Modulo61RegistroAccion from "../pages/Modulo61RegistroAccion";
import Modulo62CadenaEjecucion from "../pages/Modulo62CadenaEjecucion";
import Modulo63EscalaAjuste from "../pages/Modulo63EscalaAjuste";
import Modulo64MetricasFuncionales from "../pages/Modulo64MetricasFuncionales";
import Modulo65CicloProgreso from "../pages/Modulo65CicloProgreso";
import ResumenCapitulo6 from "../pages/ResumenCapitulo6";
import Modulo71EvaluacionFuncional from "../pages/Modulo71EvaluacionFuncional";
import Modulo72MapaPatrones from "../pages/Modulo72MapaPatrones";
import Modulo73PuntoIntervencion from "../pages/Modulo73PuntoIntervencion";
import Modulo74RedisenoPatron from "../pages/Modulo74RedisenoPatron";
import Modulo75MapaDecision from "../pages/Modulo75MapaDecision";
import ResumenCapitulo7 from "../pages/ResumenCapitulo7";
import Modulo81DiagnosticoSostenibilidad from "../pages/Modulo81DiagnosticoSostenibilidad";
import Modulo82ReinicioRapido from "../pages/Modulo82ReinicioRapido";
import Modulo83ProteccionRecaidas from "../pages/Modulo83ProteccionRecaidas";
import Modulo84RefuerzoInteligente from "../pages/Modulo84RefuerzoInteligente";
import Modulo85SistemaAutonomo from "../pages/Modulo85SistemaAutonomo";
import ResumenCapitulo8 from "../pages/ResumenCapitulo8";
import Modulo91SenalesIntegracion from "../pages/Modulo91SenalesIntegracion";
import Modulo92TransferenciaSistema from "../pages/Modulo92TransferenciaSistema";
import Modulo93CriterioPropio from "../pages/Modulo93CriterioPropio";
import Modulo94IdentidadOperativa from "../pages/Modulo94IdentidadOperativa";
import Modulo95VisionOperativa from "../pages/Modulo95VisionOperativa";
import ResumenCapitulo9 from "../pages/ResumenCapitulo9";
import CertificadoSENDA from "../pages/CertificadoSENDA";
import MisInformes from "../pages/MisInformes";
import EvolucionDashboard from "../pages/EvolucionDashboard";
import PlanSenda3x3 from "../pages/PlanSenda3x3";

// Route type: "public" | "password" | "mentor" | "usuario" | "open"
export const routeConfig = [
    // Public routes
    { path: "/login", component: Login, type: "public" },
    { path: "/recuperar-password", component: RecuperarPassword, type: "open" },
    { path: "/reset-password", component: RecuperarPassword, type: "open" },

    // Password change route
    { path: "/cambiar-password", component: CambiarPassword, type: "password" },

    // Mentor routes
    { path: "/mentor", component: MentorDashboard, type: "mentor" },
    { path: "/mentor/usuario/:userId", component: PerfilUsuario, type: "mentor" },

    // Usuario routes
    { path: "/usuario", component: UsuarioDashboard, type: "usuario" },
    // Chapter 1
    { path: "/usuario/modulo/diferencial", component: Modulo1Diferencial, type: "usuario" },
    { path: "/usuario/modulo/episodios", component: Modulo2Episodios, type: "usuario" },
    { path: "/usuario/modulo/semaforo", component: Modulo3Semaforo, type: "usuario" },
    { path: "/usuario/modulo/doble-capa", component: Modulo4DobleCapa, type: "usuario" },
    { path: "/usuario/modulo/linea-base", component: Modulo5LineaBase, type: "usuario" },
    { path: "/usuario/resumen-capitulo-1", component: ResumenCapitulo1, type: "usuario" },
    // Chapter 2
    { path: "/usuario/modulo/mapa-amenaza", component: Modulo21MapaAmenaza, type: "usuario" },
    { path: "/usuario/modulo/radar-exigencia", component: Modulo22RadarExigencia, type: "usuario" },
    { path: "/usuario/modulo/contrato-oculto", component: Modulo23ContratoOculto, type: "usuario" },
    { path: "/usuario/modulo/arbol-temor", component: Modulo24ArbolTemor, type: "usuario" },
    { path: "/usuario/modulo/radiografia", component: Modulo25Radiografia, type: "usuario" },
    { path: "/usuario/resumen-capitulo-2", component: ResumenCapitulo2, type: "usuario" },
    // Chapter 3
    { path: "/usuario/modulo/inventario-frentes", component: Modulo31InventarioFrentes, type: "usuario" },
    { path: "/usuario/modulo/deber-prestado", component: Modulo32DeberPrestado, type: "usuario" },
    { path: "/usuario/modulo/filtro-impacto", component: Modulo33FiltroImpacto, type: "usuario" },
    { path: "/usuario/modulo/tarea-faro-3", component: Modulo34TareaFaro, type: "usuario" },
    { path: "/usuario/modulo/dai", component: Modulo35DAI, type: "usuario" },
    { path: "/usuario/resumen-capitulo-3", component: ResumenCapitulo3, type: "usuario" },
    // Chapter 4
    { path: "/usuario/modulo/descomposicion-momento", component: Modulo41Descomposicion, type: "usuario" },
    { path: "/usuario/modulo/microsenales", component: Modulo42Microsenales, type: "usuario" },
    { path: "/usuario/modulo/reescritura", component: Modulo43Reescritura, type: "usuario" },
    { path: "/usuario/modulo/intervencion-vivo", component: Modulo44IntervencionVivo, type: "usuario" },
    { path: "/usuario/modulo/automatizacion", component: Modulo45Automatizacion, type: "usuario" },
    { path: "/usuario/resumen-capitulo-4", component: ResumenCapitulo4, type: "usuario" },
    // Chapter 5
    { path: "/usuario/modulo/detector-friccion", component: Modulo51DetectorFriccion, type: "usuario" },
    { path: "/usuario/modulo/vmv", component: Modulo52VMV, type: "usuario" },
    { path: "/usuario/modulo/diseno-entorno", component: Modulo53DisenoEntorno, type: "usuario" },
    { path: "/usuario/modulo/arranque-obligatorio", component: Modulo54ArranqueObligatorio, type: "usuario" },
    { path: "/usuario/modulo/sistema-ejecucion", component: Modulo55SistemaEjecucion, type: "usuario" },
    { path: "/usuario/resumen-capitulo-5", component: ResumenCapitulo5, type: "usuario" },
    // Chapter 6
    { path: "/usuario/modulo/registro-accion", component: Modulo61RegistroAccion, type: "usuario" },
    { path: "/usuario/modulo/cadena-ejecucion", component: Modulo62CadenaEjecucion, type: "usuario" },
    { path: "/usuario/modulo/escala-ajuste", component: Modulo63EscalaAjuste, type: "usuario" },
    { path: "/usuario/modulo/metricas-funcionales", component: Modulo64MetricasFuncionales, type: "usuario" },
    { path: "/usuario/modulo/ciclo-progreso", component: Modulo65CicloProgreso, type: "usuario" },
    { path: "/usuario/resumen-capitulo-6", component: ResumenCapitulo6, type: "usuario" },
    // Chapter 7
    { path: "/usuario/modulo/evaluacion-funcional", component: Modulo71EvaluacionFuncional, type: "usuario" },
    { path: "/usuario/modulo/mapa-patrones", component: Modulo72MapaPatrones, type: "usuario" },
    { path: "/usuario/modulo/punto-intervencion", component: Modulo73PuntoIntervencion, type: "usuario" },
    { path: "/usuario/modulo/rediseno-patron", component: Modulo74RedisenoPatron, type: "usuario" },
    { path: "/usuario/modulo/mapa-decision", component: Modulo75MapaDecision, type: "usuario" },
    { path: "/usuario/resumen-capitulo-7", component: ResumenCapitulo7, type: "usuario" },
    // Chapter 8
    { path: "/usuario/modulo/diagnostico-sostenibilidad", component: Modulo81DiagnosticoSostenibilidad, type: "usuario" },
    { path: "/usuario/modulo/reinicio-rapido", component: Modulo82ReinicioRapido, type: "usuario" },
    { path: "/usuario/modulo/proteccion-recaidas", component: Modulo83ProteccionRecaidas, type: "usuario" },
    { path: "/usuario/modulo/refuerzo-inteligente", component: Modulo84RefuerzoInteligente, type: "usuario" },
    { path: "/usuario/modulo/sistema-autonomo", component: Modulo85SistemaAutonomo, type: "usuario" },
    { path: "/usuario/resumen-capitulo-8", component: ResumenCapitulo8, type: "usuario" },
    // Chapter 9
    { path: "/usuario/modulo/senales-integracion", component: Modulo91SenalesIntegracion, type: "usuario" },
    { path: "/usuario/modulo/transferencia-sistema", component: Modulo92TransferenciaSistema, type: "usuario" },
    { path: "/usuario/modulo/criterio-propio", component: Modulo93CriterioPropio, type: "usuario" },
    { path: "/usuario/modulo/identidad-operativa", component: Modulo94IdentidadOperativa, type: "usuario" },
    { path: "/usuario/modulo/vision-operativa", component: Modulo95VisionOperativa, type: "usuario" },
    { path: "/usuario/resumen-capitulo-9", component: ResumenCapitulo9, type: "usuario" },
    // Certificate, reports, evolution, Plan 3x3
    { path: "/usuario/certificado", component: CertificadoSENDA, type: "usuario" },
    { path: "/usuario/mis-informes", component: MisInformes, type: "usuario" },
    { path: "/usuario/evolucion", component: EvolucionDashboard, type: "usuario" },
    { path: "/usuario/plan-senda-3x3", component: PlanSenda3x3, type: "usuario" },
];
